var _path, _path2, _g, _rect, _circle, _circle2, _path3, _path4, _g2, _path5, _path6, _g3, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBot15(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160 75H162V94H163.6C165.84 94 166.96 94 167.816 94.436C168.569 94.8195 169.181 95.4314 169.564 96.184C170 97.0397 170 98.1598 170 100.4V119.6C170 121.84 170 122.96 169.564 123.816C169.181 124.569 168.569 125.181 167.816 125.564C166.96 126 165.84 126 163.6 126H140.4C138.16 126 137.04 126 136.184 125.564C135.431 125.181 134.819 124.569 134.436 123.816C134 122.96 134 121.84 134 119.6V100.4C134 98.1598 134 97.0397 134.436 96.184C134.819 95.4314 135.431 94.8195 136.184 94.436C137.04 94 138.16 94 140.4 94H160V75ZM10 100.4C10 98.1598 10 97.0397 10.436 96.184C10.8195 95.4314 11.4314 94.8195 12.184 94.436C13.0397 94 14.1598 94 16.4 94H39.6C41.8402 94 42.9603 94 43.816 94.436C44.5686 94.8195 45.1805 95.4314 45.564 96.184C46 97.0397 46 98.1598 46 100.4V119.6C46 121.84 46 122.96 45.564 123.816C45.1805 124.569 44.5686 125.181 43.816 125.564C42.9603 126 41.8402 126 39.6 126H16.4C14.1598 126 13.0397 126 12.184 125.564C11.4314 125.181 10.8195 124.569 10.436 123.816C10 122.96 10 121.84 10 119.6V100.4Z",
    fill: "#0076DE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_43",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 75,
    width: 160,
    height: 51
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160 75H162V94H163.6C165.84 94 166.96 94 167.816 94.436C168.569 94.8195 169.181 95.4314 169.564 96.184C170 97.0397 170 98.1598 170 100.4V119.6C170 121.84 170 122.96 169.564 123.816C169.181 124.569 168.569 125.181 167.816 125.564C166.96 126 165.84 126 163.6 126H140.4C138.16 126 137.04 126 136.184 125.564C135.431 125.181 134.819 124.569 134.436 123.816C134 122.96 134 121.84 134 119.6V100.4C134 98.1598 134 97.0397 134.436 96.184C134.819 95.4314 135.431 94.8195 136.184 94.436C137.04 94 138.16 94 140.4 94H160V75ZM10 100.4C10 98.1598 10 97.0397 10.436 96.184C10.8195 95.4314 11.4314 94.8195 12.184 94.436C13.0397 94 14.1598 94 16.4 94H39.6C41.8402 94 42.9603 94 43.816 94.436C44.5686 94.8195 45.1805 95.4314 45.564 96.184C46 97.0397 46 98.1598 46 100.4V119.6C46 121.84 46 122.96 45.564 123.816C45.1805 124.569 44.5686 125.181 43.816 125.564C42.9603 126 41.8402 126 39.6 126H16.4C14.1598 126 13.0397 126 12.184 125.564C11.4314 125.181 10.8195 124.569 10.436 123.816C10 122.96 10 121.84 10 119.6V100.4Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_43)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 66,
    width: 180,
    height: 76,
    fill: "#651FFF"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 104,
    width: 180,
    height: 38,
    fill: "black",
    fillOpacity: 0.1
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 74,
    width: 2,
    height: 20,
    fill: "white",
    fillOpacity: 0.4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 161,
    cy: 71,
    r: 4,
    fill: "#E1E6E8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 162,
    cy: 70,
    r: 2,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91 13C79.9543 13 71 21.9543 71 33V36H62C61.4477 36 61 36.4477 61 37V51C61 51.5523 61.4477 52 62 52H120C120.552 52 121 51.5523 121 51V37C121 36.4477 120.552 36 120 36H111V33C111 21.9543 102.046 13 91 13Z",
    fill: "#59C4FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_0_43",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 61,
    y: 13,
    width: 60,
    height: 39
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91 13C79.9543 13 71 21.9543 71 33V36H62C61.4477 36 61 36.4477 61 37V51C61 51.5523 61.4477 52 62 52H120C120.552 52 121 51.5523 121 51V37C121 36.4477 120.552 36 120 36H111V33C111 21.9543 102.046 13 91 13Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_0_43)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 41,
    width: 100,
    height: 52,
    fill: "#BA68C8"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 91,
    cy: 30,
    rx: 4,
    ry: 6,
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 13,
    width: 60,
    height: 23,
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91 14.5C90.4477 14.5 90 14.9477 90 15.5C90 16.0523 90.4477 16.5 91 16.5V14.5ZM102.694 21.6875C103.065 22.0968 103.697 22.1281 104.107 21.7573C104.516 21.3865 104.547 20.7541 104.176 20.3448L102.694 21.6875ZM106.759 24.0473C106.504 23.5579 105.899 23.3686 105.41 23.6246C104.921 23.8806 104.731 24.4848 104.987 24.9742L106.759 24.0473ZM106.425 28.9559C106.54 29.4959 107.072 29.84 107.612 29.7244C108.152 29.6088 108.496 29.0773 108.38 28.5373L106.425 28.9559ZM91 16.5C95.6375 16.5 99.8065 18.4999 102.694 21.6875L104.176 20.3448C100.926 16.7563 96.2256 14.5 91 14.5V16.5ZM104.987 24.9742C105.636 26.2139 106.124 27.5501 106.425 28.9559L108.38 28.5373C108.041 26.9518 107.49 25.4448 106.759 24.0473L104.987 24.9742Z",
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91 44C149.352 44 155.001 84.6854 155 122C154.999 155.315 129.534 164 91 164C53.5387 164 25 155.315 25 122C25 84.6854 32.6484 44 91 44Z",
    fill: "black",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_0_43",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 44,
    width: 130,
    height: 120
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91 44C149.352 44 155.001 84.6854 155 122C154.999 155.315 129.534 164 91 164C53.5387 164 25 155.315 25 122C25 84.6854 32.6484 44 91 44Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_0_43)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 42,
    width: 138,
    height: 124,
    fill: "#4FC3F7"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 134,
    width: 6,
    height: 14,
    rx: 2,
    fill: "black",
    fillOpacity: 0.6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 134,
    width: 6,
    height: 14,
    rx: 2,
    fill: "black",
    fillOpacity: 0.6
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 134,
    width: 6,
    height: 14,
    rx: 2,
    fill: "black",
    fillOpacity: 0.6
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 134,
    width: 6,
    height: 14,
    rx: 2,
    fill: "black",
    fillOpacity: 0.6
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 48,
    transform: "translate(38 76)",
    fill: "#9F9F9F"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 86,
    width: 88,
    height: 36,
    rx: 4,
    fill: "black",
    fillOpacity: 0.8
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 97,
    width: 10,
    height: 17,
    rx: 2,
    fill: "#5EF2B8"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 97,
    width: 10,
    height: 17,
    rx: 2,
    fill: "#5EF2B8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121 86H126L114 122H109L121 86Z",
    fill: "white",
    fillOpacity: 0.4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBot15);
export default __webpack_public_path__ + "static/media/bot-15.58342e8721d877de120be46ffe5dbef9.svg";
export { ForwardRef as ReactComponent };